import "./buttons.scss";

const SubmitButton = ({ content, onClick, disabled, style }: any) => (
  <button
    className="nhsuk-button"
    data-module="nhsuk-button"
    type="submit"
    onClick={onClick}
    disabled={disabled}
    style={{...style}}
  >
    {content}
  </button>
);

export default SubmitButton;
